import apiClient from "@/api/apiClient";
import { type SignedFileUrl } from "@/hooks/useSupabaseStorage";
import {
  spawnCreateApiFunction,
  spawnGetApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";

const table = "workspace_profile_files";
const query = "*";

export const apiConfigWorkspaceProfileFiles: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [],
  sortables: [],
};

export const getWorkspaceProfileFile = spawnGetApiFunction({ table, query });
export const createWorkspaceProfileFile = spawnCreateApiFunction({ table, query });
export const updateWorkspaceProfileFile = spawnUpdateApiFunction({ table, query });

export const deleteWorkspaceProfileFile = async (file: SignedFileUrl) => {
  // we don't throw here since it doesn't affect the user if the file isn't successfully deleted (only db entity matters)
  await apiClient.storage.from(file.bucket_id).remove([file.path]);
  const { error, ...rest } = await apiClient.from(table).delete().match({
    id: file.id,
  });
  if (error) throw error;
  return { error, ...rest };
};
